var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group",
      class: {
        "has-error": _vm.errors.has("time") || _vm.errors.has("timezone")
      }
    },
    [
      _c(
        "label",
        { staticClass: "col-sm-2 control-label", attrs: { for: "time" } },
        [_vm._v("Time of activity:")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-3 col-sm-4 time-picker" },
        [
          _c("time-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate.disable",
                value: _vm.timeEntry.isAuditEdit ? "" : "required_time",
                expression: "timeEntry.isAuditEdit ? '' : 'required_time'",
                modifiers: { disable: true }
              }
            ],
            attrs: {
              name: "time",
              controls: false,
              readonly: _vm.timeEntry.isAuditEdit
            },
            model: {
              value: _vm.timeEntry.time,
              callback: function($$v) {
                _vm.$set(_vm.timeEntry, "time", $$v)
              },
              expression: "timeEntry.time"
            }
          }),
          _vm._v(" "),
          _vm.errors.has("time")
            ? _c("p", { staticClass: "text-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("time")))
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-3 col-sm-4" }, [
        _c("div", { staticClass: "select-dropdown" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: _vm.timeEntry.isAuditEdit ? "" : "required",
                  expression: "timeEntry.isAuditEdit ? '' : 'required'",
                  modifiers: { disable: true }
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.timeEntry.timezone,
                  expression: "timeEntry.timezone"
                }
              ],
              staticClass: "form-control",
              attrs: { name: "timezone", disabled: _vm.timeEntry.isAuditEdit },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.timeEntry,
                    "timezone",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { value: "PT" } }, [
                _vm._v("Pacific Time (Vancouver)")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "MT" } }, [
                _vm._v("Mountain Time (Calgary)")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "CT" } }, [
                _vm._v("Central Time (Winnipeg)")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "ET" } }, [
                _vm._v("Eastern Time (Toronto)")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "AT" } }, [
                _vm._v("Atlantic Time (Halifax)")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "NST" } }, [
                _vm._v("Newfoundland Time (St John's)")
              ])
            ]
          ),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-chevron-down" })
        ]),
        _vm._v(" "),
        _vm.errors.has("timezone")
          ? _c("p", { staticClass: "text-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("timezone")))
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-219f32ea", { render: render, staticRenderFns: staticRenderFns })
  }
}